



























































import type { PropType } from "vue"
import type { stadium_ground_price } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import AddGroundPrice from "@/views/stadium_ground/stadium_ground_price.vue"
import GroundPriceTable from "@/views/stadium_ground/stadium_ground_price_table.vue"

export default Vue.extend({
  name      : "StadiumGroundPrice",
  components: { AddGroundPrice, GroundPriceTable },
  props     : {
    stadium_id: { type: String, required: true },
    editable  : { type: Boolean, required: true },
    form      : { type: Object as PropType<stadium_ground_price> },
    show      : { type: Object,
      default() {
        return {
          all              : true,
          is_half_time     : true,
          is_people_bill   : true,
          business_time    : true,
          business_time_new: true,
        }
      }
    },
  },
  data() {
    return {
      is_half_time  : false,
      is_people_bill: false,
      origin        : [] as Array<any>,
      new_time      : [] as Array<any>,
      days          : { 1: "周一", 2: "周二", 3: "周三", 4: "周四", 5: "周五", 6: "周六", 0: "周日" }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.origin = []
        for (const v of this.form.business_time) {
          this.origin.push(v.split(","))
        }
        for (const v of this.form.business_time_new) {
          this.new_time.push(v.split(","))
        }
        const table = this.$refs.ground_price_table as any
        table.init()
      })
    },
    async change_half_time() {
      const params = { stadium_id: this.stadium_id, is_half_time: this.is_half_time ? "1" : "0" }
      const res = await this.$store.dispatch("invest/save_stadium", params);
      if (res.Code != 200) this.$error({ content: res.Message })
    },
    async change_people_bill() {
      const params = { stadium_id: this.stadium_id, is_people_bill: this.is_people_bill ? "1" : "0" }
      const res = await this.$store.dispatch("invest/save_stadium", params);
      if (res.Code != 200) this.$error({ content: res.Message })
    },
    add_origin() {
      this.$nextTick(() => {
        const add_ground_price = this.$refs.add_ground_price as any
        add_ground_price.open("原营业时间", 1, this.origin)
      })
    },
    add_new() {
      this.$nextTick(() => {
        const add_ground_price = this.$refs.add_ground_price as any
        add_ground_price.open("新增营业时间", 2, this.new_time)
      })
    },
    async reset(t: number) {
      this.$confirm({
        content: "确定删除所有已添加片场价格，进行重新添加价格？",
        onOk: async () => {
          const params = { stadium_id: this.stadium_id, type: t }
          const res = await this.$store.dispatch("stadium/resetStadiumPrice", params);
          if (res.Code == 200) this.$success({ content: "重置成功" })
          else this.$error({ content: res.Message })
        }
      })
    }
  }
})
